var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from "mobx";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class AdminAPIKeyFormModel {
    constructor(opts) {
        var _a;
        this.formModel = new FormModel({
            keyName: "",
            permissions: [],
        }, ["keyName", "permissions"]);
        this.creationResponse = { apiKey: null, apiSecret: null };
        this.deleteConfirmationModel = new SimpleDialogModel();
        this.organizationAPIKeyManager = opts.container.organizationAPIKeyManager;
        this.bannerUIManager = opts.container.bannerUIManager;
        this.onDone = opts.onDone;
        this.keyToEdit = (_a = opts.keyToEdit) !== null && _a !== void 0 ? _a : null;
        if (opts.keyToEdit) {
            this.formModel.updateInput({
                keyName: opts.keyToEdit.name,
                permissions: opts.keyToEdit.permissions,
            });
        }
    }
    done() {
        this.onDone();
    }
    async createAPIKey() {
        this.formModel.validateField("keyName", validators.notBlank, "Enter an API key name");
        const creationResponse = await this.organizationAPIKeyManager.createApiKey(this.formModel.input.keyName, this.formModel.input.permissions);
        if (creationResponse)
            this.creationResponse = creationResponse;
        this.bannerUIManager.displayBanner({ text: "API key successfully created" });
    }
    async updateAPIKey() {
        if (!this.keyToEdit) {
            return;
        }
        await this.organizationAPIKeyManager.updateApiKey(this.keyToEdit.id, this.formModel.input.keyName, this.formModel.input.permissions);
        this.bannerUIManager.displayBanner({ text: "API key successfully updated" });
        this.onDone();
    }
    showApiKeyCopySuccess() {
        this.bannerUIManager.displayBanner({ text: "API key copied to clipboard" });
    }
    showApiSecretCopySuccess() {
        this.bannerUIManager.displayBanner({ text: "API secret copied to clipboard" });
    }
    async deleteAPIKey() {
        if (!this.keyToEdit)
            return;
        const confirmed = await this.deleteConfirmationModel.showAndWait();
        if (!confirmed)
            return;
        await this.organizationAPIKeyManager.deleteApiKey(this.keyToEdit.id);
        this.onDone();
        this.bannerUIManager.displayBanner({ text: "API key successfully deleted" });
    }
}
__decorate([
    observable
], AdminAPIKeyFormModel.prototype, "creationResponse", void 0);
